import UsersList from "../Users/UsersList";
import UserRoleForm from "../Users/UserRoleForm";
import UserForm from "../Users/UserForm";
import ViewUser from "../Users/UserView";

import { permissionsConstants } from "../../constants/permission.constants";
import DisbursementView from "../Disbursement/DisbursementView";
import DrawView from "../Disbursement/DrawView";
import DisbursementFormView from "../Disbursement/DisbursementForm/DisbursementFormView";
import DisbursementRecipientList from "../Disbursement/DisbursementView/DisbursementRecipientList";
import DisbursementRedraftFormView from "../Disbursement/DisbursementForm/DisbursementRedraftFormView";
import RolesList from "../Roles/RolesList";

import InstitutionView from "../Institution/InstitutionView";
import InstitutionFormView from "../Institution/InstitutionForm/InstitutionFormView";
import ViewInstitution from "../Institution/ViewInstitution";

const {
    VIEW_USERS,
    MANAGE_USER,
    VIEW_DISBURSEMENT,
    CREATE_DISBURSEMENT,
    VIEW_INSTITUTIONS,
    MANAGE_INSTITUTIONS,
    TEST,
    // VIEW_CAMPAIGNS, CREATE_CAMPAIGN
} = permissionsConstants;

export const UserRoutes = {
    enabled: true,
    menu: true,
    routes: [
        {
            key: "users",
            title: "User Management",
            exact: true,
            icon: null,
            name: "Users",
            path: "/users",
            menu: true,
            pageComponent: UsersList,
            enabled: true,
            permissions: [VIEW_USERS],
        },
        {
            key: "addUser",
            title: "Add User",
            exact: false,
            icon: null,
            name: "Add Users",
            path: "/users/add",
            menu: false,
            pageComponent: UserForm,
            enabled: true,
            permissions: [MANAGE_USER],
        },
        {
            key: "viewUser",
            title: "View User",
            exact: false,
            icon: null,
            name: "View User",
            path: "/users/view/:id",
            menu: false,
            pageComponent: ViewUser,
            enabled: true,
            permissions: [VIEW_USERS],
        },
        {
            key: "editUser",
            title: "Edit User",
            exact: false,
            icon: null,
            name: "Edit Users",
            path: "/users/edit/:id",
            menu: false,
            pageComponent: UserForm,
            enabled: true,
            permissions: [MANAGE_USER],
        },
        {
            key: "manageUserRole",
            title: "Manage User Role",
            exact: false,
            icon: null,
            name: "Manage User Role",
            path: "/users/roles/:id",
            menu: false,
            pageComponent: UserRoleForm,
            enabled: true,
            permissions: [MANAGE_USER],
        },
    ],
};

export const DisbursementRoutes = {
    enabled: true,
    menu: true,
    routes: [
        {
            key: "disbursement",
            title: "Disbursement Management",
            exact: true,
            icon: null,
            name: "Disbursement",
            path: "/disbursement",
            menu: true,
            pageComponent: DisbursementView,
            enabled: true,
            permissions: [VIEW_DISBURSEMENT],
        },
        {
            key: "addDisbursement",
            title: "Create Disbursement",
            exact: false,
            icon: null,
            name: "Create Disbursement",
            path: "/disbursement/add",
            menu: false,
            pageComponent: DisbursementFormView,
            enabled: true,
            permissions: [CREATE_DISBURSEMENT],
        },
        {
            key: "redraftDisbursement",
            title: "Redraft Disbursement",
            exact: false,
            icon: null,
            name: "Redraft Disbursement",
            path: "/disbursement/edit/:id",
            menu: false,
            pageComponent: DisbursementFormView,
            enabled: true,
            permissions: [CREATE_DISBURSEMENT],
        },
        {
            key: "recListDisbursement",
            title: "Disbursement Recipient List",
            exact: false,
            icon: null,
            name: "Disbursement Recipient List",
            path: "/disbursement/recipient/:id",
            menu: false,
            pageComponent: DisbursementRecipientList,
            enabled: true,
            permissions: [CREATE_DISBURSEMENT],
        },
        {
            key: "viewDraws",
            title: "View Draws",
            exact: false,
            icon: null,
            name: "View Draws",
            path: "/disbursement/view/:id",
            menu: false,
            pageComponent: DrawView,
            enabled: true,
            permissions: [VIEW_DISBURSEMENT],
        },
    ],
};

export const RolesRoutes = {
    enabled: true,
    menu: true,
    routes: [
        {
            key: "roles",
            title: "Roles Management",
            exact: true,
            icon: null,
            name: "Roles",
            path: "/roles",
            menu: true,
            pageComponent: RolesList,
            enabled: true,
            permissions: [VIEW_USERS],
        },
        {
            key: "viewRole",
            title: "View Role",
            exact: false,
            icon: null,
            name: "View Role",
            path: "/roles/view/:id",
            menu: false,
            pageComponent: ViewUser,
            enabled: true,
            permissions: [VIEW_USERS],
        },
        {
            key: "editRole",
            title: "Edit Role",
            exact: false,
            icon: null,
            name: "Edit Roles",
            path: "/roles/edit/:id",
            menu: false,
            pageComponent: UserForm,
            enabled: true,
            permissions: [MANAGE_USER],
        },
    ],
};

export const InstitutionRoutes = {
    enabled: true,
    menu: true,
    routes: [
        {
            key: "institution",
            title: "Institution",
            exact: true,
            icon: null,
            name: "Institution",
            path: "/institution",
            menu: true,
            pageComponent: InstitutionView,
            enabled: true,
            permissions: [VIEW_INSTITUTIONS],
        },
        {
            key: "addInstitution",
            title: "Add Institution",
            exact: false,
            icon: null,
            name: "Add Institution",
            path: "/institution/add",
            menu: false,
            pageComponent: InstitutionFormView,
            enabled: true,
            permissions: [MANAGE_INSTITUTIONS],
        },
        {
            key: "editInstitution",
            title: "Edit Institution",
            exact: false,
            icon: null,
            name: "Edit Institution",
            path: "/institution/edit/:id",
            menu: false,
            pageComponent: InstitutionFormView,
            enabled: true,
            permissions: [MANAGE_INSTITUTIONS],
        },
        {
            key: "viewInstitution",
            title: "View Institution",
            exact: false,
            icon: null,
            name: "View Institution",
            path: "/institution/view/:id",
            menu: false,
            pageComponent: ViewInstitution,
            enabled: true,
            permissions: [VIEW_INSTITUTIONS],
        },
    ],
};
